import { render, staticRenderFns } from "./StudentApplications.vue?vue&type=template&id=9783051c&scoped=true"
import script from "./StudentApplications.vue?vue&type=script&lang=js"
export * from "./StudentApplications.vue?vue&type=script&lang=js"
import style0 from "./StudentApplications.vue?vue&type=style&index=0&id=9783051c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9783051c",
  null
  
)

export default component.exports